import React, { useEffect, useState } from 'react'
import { getWeekDate } from 'src/utils/time'


type Props = {
    setStartDate: React.Dispatch<React.SetStateAction<string>>
    setEndDate: React.Dispatch<React.SetStateAction<string>>
}

export const useSelectDate = ({ setStartDate, setEndDate }: Props) => {

    const [selectedWeek, setSelectedWeek] = useState<number>()
    const { week, startOfWeek, endOfWeek } = getWeekDate({ selectedWeek: selectedWeek! })  

    const handlePrevWeek = () => {
        setSelectedWeek((prev) => prev! - 1)
    }
    const handleNextWeek = () => {
        setSelectedWeek((prev) => prev! + 1)
    }

    useEffect(() =>{
        setSelectedWeek(week)
    },[])

    useEffect(() => {
        setStartDate(startOfWeek)
        setEndDate(endOfWeek)
    }, [startOfWeek, endOfWeek])

    return {
        handlePrevWeek,
        handleNextWeek,
        setSelectedWeek,
        selectedWeek,
        week
    }
}
 
